import React from 'react'
import { ConsentManager, onPreferencesSaved } from '@segment/consent-manager'

import { getLocalStorageConsentKey, getSegmentWriteKey } from '../../../utils'

const SegmentConsentManager = ({ layout = {} }) => {
  const { node_locale, storeSubdomain } = layout

  // NOTE: since the client wants to track right away
  // this component will not display, but we keep the functionalities
  // for display styles check ConsentManagerDisplay.js

  // relevant; change HERE
  const preferencesDialogTitle = 'Manage Consent Preferences'
  // relevant; change HERE
  const preferencesDialogContent =
    'We use data collected by cookies and JavaScript libraries to improve your browsing experience, analyze site traffic, deliver personalized advertisements, and increase the overall performance of our site.'
  // relevant; change HERE
  const cancelDialogTitle = 'Are you sure you want to cancel?'
  // relevant; change HERE
  const cancelDialogContent =
    'Your preferences have not been saved. By continuing to use our website, you՚re agreeing to our Website Data Collection Policy.'

  onPreferencesSaved((evt) => {
    localStorage.setItem(
      getLocalStorageConsentKey(storeSubdomain),
      JSON.stringify(true),
    )
  })

  return (
    <ConsentManager
      writeKey={getSegmentWriteKey(node_locale)}
      // NOTE: since the client wants to track right away
      // this banner component will not display, but we keep the functionalities
      // check ConsentManagerDisplay.js
      shouldRequireConsent={() => false}
      // shouldRequireConsent={inEU}
      closeBehavior={(categories) => ({
        ...categories,
      })}
      // bannerContent={bannerContent}
      // bannerSubContent={bannerSubContent}
      preferencesDialogTitle={preferencesDialogTitle}
      preferencesDialogContent={preferencesDialogContent}
      cancelDialogTitle={cancelDialogTitle}
      cancelDialogContent={cancelDialogContent}
      bannerBackgroundColor={'#000'}
      preferences={{ onPreferencesSaved: () => alert('Saved') }}
    />
  )
}

export default SegmentConsentManager
